<sc-flex vertical fitHeight stretchContent>
  <sc-padding>
    <sc-flex>
      <sc-cancel-action-button (click)="cancel()"></sc-cancel-action-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-action-button (click)="save()"></sc-save-action-button>
    </sc-flex>
  </sc-padding>
  <form [formGroup]="formGroup">
    <sc-string-field labelDictionaryKey="tmc-common.equipment.entity.equipment-type.name"
      formControlName="name"></sc-string-field>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-text-field [minRows]="5" labelDictionaryKey="tmc-common.equipment.entity.equipment-type.description"
      formControlName="description"></sc-text-field>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex [gap]="32">
      <sc-checkbox-field labelDictionaryKey="tmc-common.equipment.entity.equipment-type.requiresTakeback"
        formControlName="requiresTakeback"></sc-checkbox-field>
      <sc-checkbox-field labelDictionaryKey="tmc-common.equipment.entity.equipment-type.manageInstances"
        formControlName="manageInstances"></sc-checkbox-field>
      <sc-checkbox-field labelDictionaryKey="tmc-common.equipment.entity.equipment-type.disabled"
        formControlName="disabled"></sc-checkbox-field>
    </sc-flex>
  </form>

    <sc-content-spacer vertical double></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-tab-group>

        <sc-tab titleDictionaryKey="tmc-common.equipment.ui.equipment-admin.attributes-tab-title" [disabled]="!equipmentType?.manageInstances">
          <app-equipment-admin-attributes [equipmentType]="equipmentType"
            (changed)="onChange($event)"></app-equipment-admin-attributes>
        </sc-tab>

        <sc-tab titleDictionaryKey="tmc-common.equipment.ui.equipment-admin.instances-tab-title" [disabled]="!equipmentType?.manageInstances" [active]="equipmentType?.manageInstances">
          <app-equipment-admin-instances [equipmentType]="equipmentType"></app-equipment-admin-instances>
        </sc-tab>

        <sc-tab titleDictionaryKey="tmc-common.equipment.ui.equipment-admin.logs-tab-title" [active]="!equipmentType?.manageInstances">

        </sc-tab>

      </sc-tab-group>
    </sc-flex-fitting-content>

</sc-flex>
